import { createContext, useContext, useState } from "react";

const BreadcrumbContext = createContext(null);

export const BreadcrumbProvider = ({ children }) => {
  const [extraCrumbs, setExtraCrumbs] = useState(null);
  return (
    <BreadcrumbContext.Provider value={{ extraCrumbs, setExtraCrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
